import MercadoIcon from '@/components/shared/icons/mercado-icon';
import PositionIcon from '@/components/shared/icons/position';
import PromedioIcon from '@/components/shared/icons/promedio';
import PuntuacionesFantasyIcon from '@/components/shared/icons/puntuaciones-fantasy-icon';
import RachasIcon from '@/components/shared/icons/rachas-icon';
import CustomSectionWrapper from '@/DesignSystem/wrappers/CustomSectionWrapper';
import { Box, Typography, useTheme } from '@mui/material';

const InfoItem = ({ label, icon: Icon, value1, theme }) => (
    <Box
        sx={{
            boxShadow: theme.boxShadows.main,
            padding: '6px', // Más compacto
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            flex: '1 1 120px', // Más pequeño pero responsivo
            backgroundColor: theme.palette.background.default,
            border: `1px solid`,
            borderColor: 'border.main',
            transition: 'all 0.2s ease-in-out',
            width: '20%',
            '&:hover': {
                transform: 'scale(1.05)', // Pequeña animación en hover
                boxShadow: theme.shadows.hover,
            },
        }}
    >
        <Typography fontSize={12} fontWeight="500" color={theme.palette.text.secondary} mb={1} variant="h3">
            {label}
        </Typography>

        {Icon && <Icon width={25} height={25} />}

        <Typography sx={{ fontSize: 14, fontWeight: 'bold', color: theme.mercado.up }} mt={1}>
            {value1}
        </Typography>
    </Box>
);

const CoeficienteAnalitica = ({ player }) => {
    const theme = useTheme();
    const marketRise = player?.ca?.m?.i;
    const fantasyPoints = player?.ca?.pt?.i;
    const rachaPoints = player?.ca?.rc?.i;
    const betAverageCA = player?.ca?.pr?.i;
    const positionPoints = player?.ca?.pos?.i;

    return (
        <CustomSectionWrapper color="accent" title="Ranking de jugadores  ">
            <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
                <InfoItem theme={theme} label="Subida" icon={MercadoIcon} value1={`Top ${marketRise}`} />
                <InfoItem
                    theme={theme}
                    label="Puntos"
                    icon={PuntuacionesFantasyIcon}
                    value1={`Top ${fantasyPoints}`}
                />
                <InfoItem theme={theme} label="Racha" icon={RachasIcon} value1={`Top ${rachaPoints}`} />
                <InfoItem theme={theme} label="Media" icon={PromedioIcon} value1={`Top ${betAverageCA}`} />
                <InfoItem
                    theme={theme}
                    label="Posición"
                    icon={PositionIcon}
                    value1={`Top ${positionPoints}`}
                />
            </Box>
        </CustomSectionWrapper>
    );
};

export default CoeficienteAnalitica;
